export default __webpack_public_path__ + "static/media/testimonial-logo.f42aa271.png";